import { fetchJson } from 'src/utils';

/** 检查用户是否有商城权益 */
export const checkRights = () => fetchJson({
  url: '/api/api/v1/patient/user/rights/mallRights/isExistAvailable',
  type: 'GET',
});
